import{parseCssStyles as r}from"./parse-styles.js";var t=function(t){return function(n){return r(t,null,n)}};export{t as default};
//# sourceMappingURL=css.js.map
